import React, { useEffect } from "react";
import "./Solution2.css";
import { Shield, Database, Scale, BarChart, TrendingUp } from "lucide-react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
const BackupandDisaster = () => {
  useEffect(() => {
    window.scrollTo(0, 0);  
  }, []);
  const featureCards = [
    {
      icon: <Shield className="feature-icon" />,
      title: "Reliable Protection",
      description:
        "Our BDR solutions offer robust data protection mechanisms, safeguarding your critical business data against various threats, including hardware failures, cyberattacks, and human errors. With multiple layers of redundancy and encryption protocols, you can rest assured that your data is safe and accessible when you need it the most.​",
    },
    {
      icon: <Database className="feature-icon" />,
      title: "Continuous Data Availability",
      description:
        "Minimize downtime and ensure seamless operations with our continuous data replication and backup strategies. Our solutions are engineered to provide real-time data synchronization, enabling swift recovery in the event of system failures or disasters. Whether it's a single file or an entire system, you can recover your data swiftly and efficiently, minimizing the impact on your business operations.",
    },
    {
      icon: <Scale className="feature-icon" />,
      title: "Scalability and Flexibility",
      description:
        "Our BDR solutions are tailored to accommodate the evolving needs of your business. Whether you're a small startup or a large enterprise, our scalable solutions can adapt to your growing data requirements seamlessly. With flexible deployment options, including on-premises, cloud-based, or hybrid models, you have the freedom to choose the setup that best aligns with your business objectives and budget constraints.​",
    },
    {
      icon: <TrendingUp className="feature-icon" />,
      title: "Comprehensive Disaster Recovery Planning",
      description:
        " We understand that every business is unique, with its own set of challenges and priorities. That's why our team of experts works closely with you to develop customized disaster recovery plans tailored to your specific requirements. From risk assessment and mitigation strategies to recovery point objectives (RPO) and recovery time objectives (RTO), we ensure that your business is well-prepared to handle any unforeseen disruptions effectively.​",
    },
    {
      icon: <BarChart className="feature-icon" />,
      title: "Cost-Efficiency",
      description:
        "Investing in our BDR solutions is not just about mitigating risks; it's also about optimizing your IT spending. By consolidating your backup and disaster recovery infrastructure, you can eliminate unnecessary redundancies and streamline your operational costs. With predictable pricing models and transparent billing, you can achieve cost-efficiency without compromising on the quality of service.​",
    },
  ];

  return (
    <>
      <Header />
      <div className="resilience-container">
        <div className="hero-section">
          <div className="hero-content">
            <div className="backup-container">
              <a href="/solutions#Infrastructure" className="backup-text">
                Solution
              </a>
             <p>/Backup and Disaster Recover</p>
            </div>

            <div className="hero-wrapper">
              <div className="hero-text-container">
                <div className="hero-text-content">
                  <h1 className="hero-title">
                    <span className="hero-title-main">
                      Backup and Disaster Recovery
                    </span>
                  </h1>
                  <p className="hero-subtitle">
                    Safeguard Your Business with Robust Backup and Disaster
                    Recovery Solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="introduction-text">
            In today's rapidly evolving technological landscape, ensuring the
            continuity of your business operations is paramount. Disruptions
            such as data loss, system failures, or natural disasters can occur
            unexpectedly, posing significant threats to your organization's
            productivity, reputation, and bottom line. That's why our
            comprehensive Backup and Disaster Recovery (BDR) solutions are
            meticulously designed to safeguard your business assets and mitigate
            potential risks.
          </div>

          <h2 className="section-title">
            Why Choose Our Backup and Disaster Recovery Solutions?
          </h2>

          <div className="feature-grid">
            {featureCards.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon-wrapper">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
          <br />
          <br />
          <h2 className="highlighted-section-title">
            Take the First Step Towards Secure and Resilient Business Operations
          </h2>
          <div className="highlighted-introduction-text">
            Don't wait until it's too late. Protect your business against
            unforeseen disruptions with our comprehensive Backup and Disaster
            Recovery solutions. Whether you're looking to enhance data security,
            minimize downtime, or ensure regulatory compliance, we have the
            expertise and resources to support your business needs. Contact us
            today to learn more about how our BDR solutions can safeguard your​
          </div>
          <br /> <br />
          <div className="software-contact-button-wrapper">
            <a
              href="/contactus?subject=Backup%20and%20Disaster%20Recovery"
              className="software-contact-button"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BackupandDisaster;
